import { TransportOrderIdView } from '../../../models';

export class ShipmentTransportOrderItemSetIdentifier {
  public static readonly type = '[ShipmentTransportOrderItem] Set Shipment Waybill Identifier';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderItemNotificationListCountLoad {
  public static readonly type = '[ShipmentTransportOrderItemNotificationList] Notification List Load';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderItemSetInitial {
  public static readonly type = '[ShipmentTransportOrderItem] Set Initial State';
}
